import React from 'react';

const DataTable = ({ headers, rows, title, tag }) => (
    <div className="pa-table-card">
        {(title || tag) && (
            <div className="pa-table-card-head">
                {title && <h3>{title}</h3>}
                {tag && <span className="pa-example-tag">{tag}</span>}
            </div>
        )}
        <div className="pa-table-wrap">
            <table className="pa-data-table">
                <thead>
                    <tr>
                        {headers.map((header) => (
                            <th key={header}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex}>{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
);

export default DataTable;
